/**
 * used to inititate select dropdown element
 * @param {string} element string
 * @param {string} placeholderMessage to show on placeholder
 * @param {string} noResultMessage to show when no result
 */
function initiateSelectDropDown(element, placeholderMessage, noResultMessage) {
    if ($(element).length > 0) {
        $(element).select2({
            // placeholder: resources.pleaseSelect,
            language: {
                noResults: function (params) {
                    return noResultMessage;
                }
            }
        });

        $(element).one('select2:open', function (e) {
            $('input.select2-search__field').prop(
                'placeholder',
                placeholderMessage
            );
        });

        $(element).on('select2:close', function (e) {
            $(element).select2('destroy');

            $(element).select2({
                placeholder: resources.pleaseSelect,
                language: {
                    noResults: function (params) {
                        return noResultMessage;
                    }
                }
            });

            $(element).one('select2:open', function (e) {
                $('input.select2-search__field').prop(
                    'placeholder',
                    placeholderMessage
                );
            });
        });
    }
}


module.exports = {
    initiateSelectDropDown: initiateSelectDropDown
}